import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../default-cloud-graph-remote-link-entity-ati';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { WebexIcon } from './icon';
import { WebexIconBorderless } from './icon-borderless';
import { WebexSearchResultIcon } from './search-result-icon';

export const webexConfig: ThirdPartyConfig = {
	displayName: 'Webex',
	id: 'webex',
	resourceType: 'smartlinks-connector-webex',
	icon: get3PLogo(WebexIcon, 'Webex', 'medium'),
	iconBorderless: get3PLogo(WebexIconBorderless, 'Webex', 'small'),
	searchResultIcon: get3PLogo(WebexSearchResultIcon, 'Webex', 'large'),
	integrationAri: 'ari:cloud:platform::integration/cisco',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Video],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
